// src/FeedbackIcon.tsx
import { jsx } from "react/jsx-runtime";
var FeedbackIcon = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 0.32 0.32",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#fff",
        d: "M0.151 0.202q0.014 0.005 0.025 0.015 0.011 0.009 0.019 0.021a0.097 0.097 0 0 1 0.017 0.054v0.009h-0.017v-0.009a0.079 0.079 0 0 0 -0.023 -0.056 0.08 0.08 0 0 0 -0.025 -0.017 0.08 0.08 0 0 0 -0.031 -0.006 0.079 0.079 0 0 0 -0.056 0.023 0.08 0.08 0 0 0 -0.017 0.025q-0.006 0.014 -0.006 0.031v0.009H0.02v-0.009a0.093 0.093 0 0 1 0.017 -0.054 0.099 0.099 0 0 1 0.045 -0.035 0.067 0.067 0 0 1 -0.011 -0.01 0.067 0.067 0 0 1 -0.008 -0.012 0.067 0.067 0 0 1 -0.005 -0.014 0.067 0.067 0 0 1 -0.002 -0.015q0 -0.013 0.005 -0.024A0.063 0.063 0 0 1 0.092 0.095 0.061 0.061 0 0 1 0.14 0.095a0.063 0.063 0 0 1 0.033 0.033 0.061 0.061 0 0 1 0.003 0.039q-0.002 0.007 -0.005 0.014a0.067 0.067 0 0 1 -0.008 0.012q-0.005 0.006 -0.011 0.01m-0.035 -0.007q0.009 0 0.017 -0.003a0.044 0.044 0 0 0 0.023 -0.023q0.004 -0.008 0.004 -0.017a0.043 0.043 0 0 0 -0.013 -0.031 0.053 0.053 0 0 0 -0.014 -0.009 0.04 0.04 0 0 0 -0.017 -0.004q-0.009 0 -0.017 0.003a0.044 0.044 0 0 0 -0.023 0.023q-0.003 0.008 -0.003 0.017t0.003 0.017 0.009 0.014a0.044 0.044 0 0 0 0.031 0.013zM0.3 0.02V0.16h-0.035l-0.053 0.053V0.16h-0.017v-0.017h0.035v0.028l0.028 -0.028h0.025V0.038H0.107v0.031L0.099 0.07a0.053 0.053 0 0 0 -0.009 0.002V0.02z"
      }
    )
  }
);
var FeedbackIcon_default = FeedbackIcon;

export {
  FeedbackIcon_default
};
